
 
export const FETCH_STREET_TYPES_REQUEST = 'streetTypes/FETCH_STREET_TYPES_REQUEST';
export const FETCH_STREET_TYPES_SUCCESS = 'streetTypes/FETCH_STREET_TYPES_SUCCESS';
export const FETCH_STREET_TYPES_FAILURE = 'streetTypes/FETCH_STREET_TYPES_FAILURE';

 
export const FETCH_STREET_TYPE_REQUEST = 'street/FETCH_STREET_TYPE_REQUEST';
export const FETCH_STREET_TYPE_SUCCESS = 'street/FETCH_STREET_TYPE_SUCCESS';
export const FETCH_STREET_TYPE_FAILURE = 'street/FETCH_STREET_TYPE_FAILURE';

 
export const DELETE_STREET_TYPE_REQUEST = 'streetTypes/DELETE_STREET_TYPE_REQUEST';
export const DELETE_STREET_TYPE_SUCCESS = 'streetTypes/DELETE_STREET_TYPE_SUCCESS';
export const DELETE_STREET_TYPE_FAILURE = 'streetTypes/DELETE_STREET_TYPE_FAILURE';

 
export const CREATE_STREET_TYPE_REQUEST = 'streetTypes/CREATE_STREET_TYPE_REQUEST';
export const CREATE_STREET_TYPE_SUCCESS = 'streetTypes/CREATE_STREET_TYPE_SUCCESS';
export const CREATE_STREET_TYPE_FAILURE = 'streetTypes/CREATE_STREET_TYPE_FAILURE';

 
export const UPDATE_STREET_TYPE_REQUEST = 'streetTypes/UPDATE_STREET_TYPE_REQUEST';
export const UPDATE_STREET_TYPE_SUCCESS = 'streetTypes/UPDATE_STREET_TYPE_SUCCESS';
export const UPDATE_STREET_TYPE_FAILURE = 'streetTypes/UPDATE_STREET_TYPE_FAILURE';


export const UPDATE_FIELD = 'streetTypes/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'streetTypes/SET_DEFAULT_DATA';
